<div class="cont-title-sec mb-30">
  <h1 class="title-sect color-blue-dark font-30 f-31 wr-100">
    Retiro de Trabajadores
  </h1>
</div>

<div class="row ">
  <div class="col-xs-12 col-lg-6 mg-btm-30">
    <div class="card bg-white shadow-item">
      <div class="d-flex">
        <div class="item-img col-xs-12 col-sm-5">
          <div class="row">
            <img [src]="pIndividual.url" class="img-responsive" alt="Ir a Retiro individual">
          </div>
        </div>
        <div class="d-flex item-text color-gray-light col-xs-12 col-sm-7 justify-content-center">
          <div class="header-card d-flex bottom-xs">
            <h2 class="color-gray header-card_title u-medium f-20 wr-100">{{pIndividual.text}}</h2>
          </div>
          <p class="f-14 t-align-center">
            {{pIndividual.secondary_text}}
          </p>
          <div class="mg-top-40"></div>
          <a
          appDebounceClick aria-label="pIndividual.secondary_text" id="Retiro_PTEC-retiro individual" title="Ir a Retirar un trabajador"
          [routerLink]="'/'+urlIndividualRetiro"
            class="u-btn u-btn--blue text-center btn-affiliate">Retirar trabajador</a>
        </div>
      </div>
    </div>
  </div><!-- /col -->
  <div class="col-xs-12 col-lg-6 mg-btm-30 m-t-30">
    <div class="card bg-white shadow-item">
      <div class="d-flex">
        <div class="item-img col-xs-12 col-sm-5">
          <div class="row">
            <img [src]="pMassive.url" class="img-responsive" alt="Ir a Retiro masivo">
          </div>
        </div>
        <div class="d-flex item-text color-gray-light col-xs-12 col-sm-7 justify-content-center">
          <div class="header-card d-flex bottom-xs">
            <h2 class="color-gray header-card_title u-medium f-20 wr-100">{{pMassive.text}}</h2>
          </div>
          <p class="f-14 t-align-center">
            {{pMassive.secondary_text}}
          </p>
          <div class="mg-top-40"></div>
          <div>
            <a
            appDebounceClick id="Retiro_PTEC-retiro Mass" title="Retirar trabajadores"
            [routerLink]="'/'+urlMassRetiro" class="u-btn u-btn--blue text-center btn-affiliate r-hide">
              Retirar trabajadores
            </a>

            <!-- <a
            appDebounceClick id="Retiro_PTEC-retiro MassModal" title="Retirar trabajadores"
            class="u-btn u-btn--blue text-center btn-affiliate d-none r-show" (click)="clickToggle()">
              Retirar trabajadores masivo 
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-none modal-overlay" [ngClass]="{ 'modal-show': modal }">
  <div class="modal-content">
    <h2 class="f-20 t-align-center">
      ¡Advertencia!
    </h2>

    <div class="ctn-icon">
      <img class="icon-warning" src="./assets/icons/warning-yellow.svg" alt="Icono de Advertencia">
    </div>

    <p class="f-14 t-align-center">
      Este proceso puede manejar altos volúmenes de información, por esto,
      te recomendamos realizarlo desde un computador.
    </p>

    <a
    appDebounceClick id="Retiro_PTEC-retiro" title="Retirar trabajadores"
    class="u-btn u-btn--blue text-center modal-btn" (click)="clickToggle()">
      Regresar
    </a>
  </div>
</div>
